import type { PropertyBackedLoanHeroContent } from 'modules/property-backed-loan-hero'

export const homeRenovationHeroContent: PropertyBackedLoanHeroContent = {
  breadcrumbLabel: 'Empréstimo para Reforma de Casa',
  titleFirstLine: 'Empréstimo para',
  titleHighlight: 'Reforma de Casa',
  description: (
    <>
      <strong>Crédito com Garantia de Imóvel para reformar sua casa e transformar planos em realidade.</strong>
      <br />
      <br />
      Para modernizar o apartamento, investir em decoração ou realizar uma reforma completa, a CashMe ajuda você a
      acessar o crédito certo.
    </>
  ),
  benefits: [
    'Crédito a partir de R$ 50 mil',
    'Taxas mais baixas e prazos longos',
    '100% digital, rápido e sem burocracia'
  ]
}
